<jb-dialog dialogType="content">
  <jb-dialog-header>{{
    flightTrackerText?.dialogMobileTitle
  }}</jb-dialog-header>
  <jb-dialog-content>
    <div *ngIf="flightTrackerText">
      <div class="pb4 ph5 flex justify-between">
        <span>
          {{ flightTrackerText?.lastUpdated }}
          {{ currentTime | date: 'h:mma' | lowercase }}
        </span>
        <jb-action
          id="action-button-icon"
          actionIcon="reload"
          (click)="refreshFlightData()"
        >
          {{ flightTrackerText?.refreshStatus }}
        </jb-action>
      </div>
      <ng-container *ngIf="!refreshing">
        <div class="w-90 pv2 mb3 center bb b--black-20"></div>
        <div class="pa3 dialog-pb">
          <div class="flex flex-row pl3">
            <div class="flex flex-column w-50">
              <div class="b">
                {{ flightTrackerText?.tabletStickyFlightNumber }}
              </div>
              <div class="l-body pt2 mt2">{{ dialogFlightNo }}</div>
            </div>
            <div
              *ngIf="!(dialogStatus | jbIncludesSubstring: 'TROUBLE')"
              class="flex flex-column w-50"
            >
              <div class="b">{{ flightTrackerText?.tabletStickyStatus }}</div>
              <div class="body pt2 mt2 core-blue b">
                <span class="{{ setStatusColor(dialogStatus) }}">&#9679; </span>
                <span>{{
                  dialogStatus
                    | dotCapitalizeFlightStatus: originAndDestinationAirport
                }}</span>
                <div>
                  <jb-icon
                    *ngIf="dialogStatus | jbIncludesSubstring: 'MINT'"
                    class="pl1 fill-mint-green"
                    name="mintIndicator"
                    width="1.5em"
                    height="1.5em"
                  ></jb-icon>
                  <jb-icon
                    name="mosaicFullColor"
                    *ngIf="dialogStatus | jbIncludesSubstring: 'MOSAIC'"
                    class="pl1"
                  ></jb-icon>
                </div>
                <jb-icon
                  name="emsLogo"
                  *ngIf="dialogStatus | jbIncludesSubstring: 'GROUP A'"
                  class="pl1"
                ></jb-icon>
              </div>
            </div>
          </div>
          <div class="w-90 mv3 bb b--black-20 center"></div>
          <div
            *ngIf="dialogStatus | jbIncludesSubstring: 'CANCELLED'"
            class="ph3 pv2"
          >
            {{ flightTrackerText?.flightCancelledMsgPrefix }}
            <a [jbSitemapLinker]="'/contact-us'">{{
              flightTrackerText?.contactUs
            }}</a>
            {{ flightTrackerText?.forAssistance }}
          </div>
          <div
            *ngIf="!(dialogStatus | jbIncludesSubstring: 'CANCELLED')"
            class="flex flex-row pl3"
          >
            <div class="flex flex-column w-40">
              <div class="b pv1">
                {{ flightTrackerText?.tabletStickyOrigin }}
              </div>
              <div class="l-body pv1 mt1">{{ dialogOrigin }}</div>
              <div class="flex flex-auto">
                <span>
                  {{ flightTrackerText?.terminal }} {{ dialogOriginTerminal }}
                </span>
              </div>
              <div class="flex flex-auto items-end">
                <span>
                  {{ flightTrackerText?.gate }} {{ dialogOriginGate }}
                </span>
              </div>
              <div
                *ngIf="
                  dialogOriginTerminal === null && dialogOriginGate === null
                "
                class="flex flex-auto"
              ></div>
              <div class="pt3 mt2 b">
                {{ flightTrackerText?.dialogDeparture }}
              </div>
              <div class="l-body pv1 mt2 b">
                {{ convertTime(dialogScheduledDeparture) | date: 'shortTime' }}
              </div>
              <div
                *ngIf="
                  (dialogNewDeparture !== dialogScheduledDeparture ||
                    dialogNewArrival !== dialogScheduledArrival ||
                    (dialogStatus | jbIncludesSubstring: 'DELAY')) &&
                  (dialogNewArrival !== null || dialogNewDeparture !== null)
                "
                class="pt1"
              >
                <span
                  *ngIf="dialogStatus | jbIncludesSubstring: 'DELAY'"
                  class="orange"
                  >&#9679;</span
                >
                {{ flightTrackerText?.now }}
                {{ convertTime(dialogNewDeparture) | date: 'shortTime' }}
              </div>
            </div>
            <div class="flex flex-column w-10">
              <div class="pt5 relative arrow-position">
                <jb-icon
                  class="fill-medium-gray"
                  name="rightFilled"
                  width="1.5em"
                  height="1.5em"
                ></jb-icon>
              </div>
            </div>
            <div class="flex flex-column w-40">
              <div class="b pv1">
                {{ flightTrackerText?.tabletStickyDestination }}
              </div>
              <div class="l-body pv1 mt1">{{ dialogDestination }}</div>
              <div class="flex flex-auto">
                <span>
                  {{ flightTrackerText?.terminal }}
                  {{ dialogDestinationTerminal }}
                </span>
              </div>
              <div class="flex flex-auto items-end">
                <span>
                  {{ flightTrackerText?.gate }} {{ dialogDestinationGate }}
                </span>
              </div>
              <div
                *ngIf="
                  dialogDestinationTerminal === null &&
                  dialogDestinationGate === null
                "
                class="flex flex-auto"
              ></div>
              <div class="pt3 mt2 b">
                {{ flightTrackerText?.dialogArrival }}
              </div>
              <div class="l-body pv1 mt2 b">
                {{ convertTime(dialogScheduledArrival) | date: 'shortTime' }}
              </div>
              <div
                *ngIf="
                  (dialogNewDeparture !== dialogScheduledDeparture ||
                    dialogNewArrival !== dialogScheduledArrival ||
                    (dialogStatus | jbIncludesSubstring: 'DELAY')) &&
                  (dialogNewArrival !== null || dialogNewDeparture !== null)
                "
                class="pt1"
              >
                <span
                  *ngIf="dialogStatus | jbIncludesSubstring: 'DELAY'"
                  class="orange"
                  >&#9679;</span
                >
                {{ flightTrackerText?.now }}
                {{ convertTime(dialogNewArrival) | date: 'shortTime' }}
              </div>
            </div>
          </div>
          <div
            *ngIf="dialogStatus | jbIncludesSubstring: 'DELAY'"
            class="pt3 ph3"
          >
            {{ flightTrackerText?.flightDelayedMsg }}
          </div>
          <div *ngIf="dialogStatus | jbIncludesSubstring: 'NOW'" class="pa3">
            {{ flightTrackerText?.newOriginMsg }}
            {{ dialogScheduledOriginAirport
            }}{{ flightTrackerText?.newOriginPeriod }}
          </div>
          <div
            class="flex w-100 h-100"
            *ngIf="
              !(dialogStatus | jbIncludesSubstring: 'CANCELLED') &&
              isInFlight(dialogNewDeparture, dialogNewArrival) &&
              ((dialogStatus | jbIncludesSubstring: 'IN FLIGHT') ||
                (dialogStatus | jbIncludesSubstring: 'RETURN'))
            "
          ></div>
          <div
            *ngIf="
              !(dialogStatus | jbIncludesSubstring: 'TROUBLE') &&
              !(dialogStatus | jbIncludesSubstring: 'CANCELLED') &&
              dialogNewArrival !== null &&
              dialogNewDeparture !== null &&
              isInFlight(dialogNewDeparture, dialogNewArrival)
            "
            class="pt3 pb1 pl3 b"
          >
            {{ flightTrackerText?.dialogRemainingFlightTime }}
          </div>
          <div
            *ngIf="
              !(dialogStatus | jbIncludesSubstring: 'TROUBLE') &&
              !(dialogStatus | jbIncludesSubstring: 'CANCELLED') &&
              dialogNewArrival !== null &&
              dialogNewDeparture !== null &&
              isInFlight(dialogNewDeparture, dialogNewArrival)
            "
            class="pv1 pl3"
          >
            {{ calculateRemainingTime(dialogNewArrival) }}
          </div>
          <div class="w-90 pv2 mb3 center bb b--black-20"></div>

          <div class="ph3">
            <jb-flight-tracker-results-inbound-plane
              [flightTrackerLeg]="leg"
              [flightTrackerText]="flightTrackerText"
              [useDialogDisplay]="true"
            />
          </div>
        </div>

        <div *ngIf="dialogSecondFlightNo !== ''">
          <span class="fl w-100 bb b--black-20"></span>
          <span class="fl w-100 pv3 bg-black-05"></span>
          <div class="pa3">
            <span class="fl w-100 bg-white pv3"></span>
            <div class="flex flex-row w-100 pl3">
              <div class="flex flex-column w-50">
                <div class="b">
                  {{ flightTrackerText?.tabletStickyFlightNumber }}
                </div>
                <div class="l-body pt2 mt2">{{ dialogSecondFlightNo }}</div>
              </div>
              <div
                *ngIf="!(dialogSecondStatus | jbIncludesSubstring: 'TROUBLE')"
                class="flex flex-column w-50"
              >
                <div class="b">{{ flightTrackerText?.tabletStickyStatus }}</div>
                <div class="body pt2 mt2 core-blue b">
                  <span class="{{ setStatusColor(dialogSecondStatus) }}"
                    >&#9679;
                  </span>
                  <span>{{
                    dialogSecondStatus
                      | dotCapitalizeFlightStatus
                        : secondOriginAndDestinationAirport
                  }}</span>
                  <div>
                    <jb-icon
                      *ngIf="dialogSecondStatus | jbIncludesSubstring: 'MINT'"
                      class="pl1 fill-mint-green"
                      name="mintIndicator"
                      width="1.5em"
                      height="1.5em"
                    ></jb-icon>
                    <jb-icon
                      name="mosaicFullColor"
                      *ngIf="dialogSecondStatus | jbIncludesSubstring: 'MOSAIC'"
                      class="pl1"
                    >
                    </jb-icon>
                  </div>
                  <jb-icon
                    name="emsLogo"
                    *ngIf="dialogSecondStatus | jbIncludesSubstring: 'GROUP A'"
                    class="pl1"
                  ></jb-icon>
                </div>
              </div>
            </div>
            <div class="w-90 mv3 bb b--black-20 center"></div>
            <div
              *ngIf="dialogSecondStatus | jbIncludesSubstring: 'CANCELLED'"
              class="ph3 pv2"
            >
              {{ flightTrackerText?.flightCancelledMsgPrefix }}
              <a [jbSitemapLinker]="'/contact-us'">{{
                flightTrackerText?.contactUs
              }}</a>
              {{ flightTrackerText?.forAssistance }}
            </div>
            <div
              *ngIf="!(dialogSecondStatus | jbIncludesSubstring: 'CANCELLED')"
              class="flex flex-row pl3"
            >
              <div class="flex flex-column w-40">
                <div class="b pv1">
                  {{ flightTrackerText?.tabletStickyOrigin }}
                </div>
                <div class="l-body pv1 mt1">{{ dialogSecondOrigin }}</div>
                <div class="flex flex-auto">
                  <span>
                    {{ flightTrackerText?.terminal }}
                    {{ dialogSecondOriginTerminal }}
                  </span>
                </div>
                <div class="flex flex-auto items-end">
                  <span>
                    {{ flightTrackerText?.gate }} {{ dialogSecondOriginGate }}
                  </span>
                </div>
                <div
                  *ngIf="
                    dialogSecondOriginTerminal === null &&
                    dialogSecondOriginGate === null
                  "
                  class="flex flex-auto"
                ></div>
                <div class="pt3 mt2 b">
                  {{ flightTrackerText?.dialogDeparture }}
                </div>
                <div class="l-body pv1 mt2 b">
                  {{
                    convertTime(dialogSecondScheduledDeparture)
                      | date: 'shortTime'
                  }}
                </div>
                <div
                  *ngIf="
                    (dialogSecondNewDeparture !==
                      dialogSecondScheduledDeparture ||
                      dialogSecondNewArrival !== dialogSecondScheduledArrival ||
                      (dialogSecondStatus | jbIncludesSubstring: 'DELAY')) &&
                    (dialogSecondNewArrival !== null ||
                      dialogSecondNewDeparture !== null)
                  "
                  class="pt1"
                >
                  <span
                    *ngIf="dialogSecondStatus | jbIncludesSubstring: 'DELAY'"
                    class="orange"
                    >&#9679;</span
                  >
                  {{ flightTrackerText?.now }}
                  {{
                    convertTime(dialogSecondNewDeparture) | date: 'shortTime'
                  }}
                </div>
              </div>
              <div class="flex flex-column w-10">
                <div class="pt5 relative arrow-position">
                  <jb-icon
                    class="fill-medium-gray"
                    name="rightFilled"
                    width="1.5em"
                    height="1.5em"
                  ></jb-icon>
                </div>
              </div>
              <div class="flex flex-column w-40">
                <div class="b pv1">
                  {{ flightTrackerText?.tabletStickyDestination }}
                </div>
                <div class="l-body pv1 mt1">{{ dialogSecondDestination }}</div>
                <div class="flex flex-auto">
                  <span>
                    {{ flightTrackerText?.terminal }}
                    {{ dialogSecondDestinationTerm }}
                  </span>
                </div>
                <div class="flex flex-auto items-end">
                  <span>
                    {{ flightTrackerText?.gate }}
                    {{ dialogSecondDestinationGate }}
                  </span>
                </div>
                <div
                  *ngIf="
                    dialogSecondDestinationTerm === null &&
                    dialogSecondDestinationGate === null
                  "
                  class="flex flex-auto"
                ></div>
                <div class="pt3 mt2 b">
                  {{ flightTrackerText?.dialogArrival }}
                </div>
                <div class="l-body pv1 mt2 b">
                  {{
                    convertTime(dialogSecondScheduledArrival)
                      | date: 'shortTime'
                  }}
                </div>
                <div
                  *ngIf="
                    (dialogSecondNewDeparture !==
                      dialogSecondScheduledDeparture ||
                      dialogSecondNewArrival !== dialogSecondScheduledArrival ||
                      (dialogSecondStatus | jbIncludesSubstring: 'DELAY')) &&
                    (dialogSecondNewArrival !== null ||
                      dialogSecondNewDeparture !== null)
                  "
                  class="pt1"
                >
                  <span
                    *ngIf="dialogSecondStatus | jbIncludesSubstring: 'DELAY'"
                    class="orange"
                    >&#9679;</span
                  >
                  {{ flightTrackerText?.now }}
                  {{ convertTime(dialogSecondNewArrival) | date: 'shortTime' }}
                </div>
              </div>
            </div>
            <div
              *ngIf="dialogSecondStatus | jbIncludesSubstring: 'DELAY'"
              class="pt3 ph3"
            >
              {{ flightTrackerText?.flightDelayedMsg }}
            </div>
            <div
              *ngIf="dialogSecondStatus | jbIncludesSubstring: 'NOW'"
              class="pa3"
            >
              {{ flightTrackerText?.newOriginMsg }}
              {{ dialogSecondScheduledOriginAirport
              }}{{ flightTrackerText?.newOriginPeriod }}
            </div>
            <div
              class="flex w-100 h-100"
              *ngIf="
                !(dialogSecondStatus | jbIncludesSubstring: 'CANCELLED') &&
                isInFlight(dialogSecondNewDeparture, dialogSecondNewArrival) &&
                ((dialogSecondStatus | jbIncludesSubstring: 'IN FLIGHT') ||
                  (dialogSecondStatus | jbIncludesSubstring: 'RETURN'))
              "
            ></div>
            <div
              *ngIf="
                !(dialogSecondStatus | jbIncludesSubstring: 'TROUBLE') &&
                !(dialogSecondStatus | jbIncludesSubstring: 'CANCELLED') &&
                dialogSecondNewArrival !== null &&
                dialogSecondNewDeparture !== null &&
                isInFlight(dialogSecondNewDeparture, dialogSecondNewArrival)
              "
              class="pt3 pb1 pl3 b"
            >
              {{ flightTrackerText?.dialogRemainingFlightTime }}
            </div>
            <div
              *ngIf="
                !(dialogSecondStatus | jbIncludesSubstring: 'TROUBLE') &&
                !(dialogSecondStatus | jbIncludesSubstring: 'CANCELLED') &&
                dialogSecondNewArrival !== null &&
                dialogSecondNewDeparture !== null &&
                isInFlight(dialogSecondNewDeparture, dialogSecondNewArrival)
              "
              class="pv1 pl3"
            >
              {{ calculateRemainingTime(dialogSecondNewArrival) }}
            </div>
            <div class="w-90 pv2 mb3 center bb b--black-20"></div>

            <div class="ph3">
              <jb-flight-tracker-results-inbound-plane
                [flightTrackerLeg]="flightTrackerConnectingResults"
                [flightTrackerText]="flightTrackerText"
                [useDialogDisplay]="true"
              />
            </div>

            <span class="fl w-100 bg-white pv7"></span>
          </div>
        </div>
      </ng-container>
    </div>
  </jb-dialog-content>
</jb-dialog>
